var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 486.61 167.6",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF4500;}\n\t.st1{fill:#222222;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{display:none;}\n\t.st4{display:inline;fill:none;stroke:#D8D8D8;stroke-width:0.4925;stroke-miterlimit:10;}\n\t.st5{display:inline;fill:none;stroke:#D8D8D8;stroke-width:0.5589;stroke-miterlimit:10;}\n\t.st6{display:inline;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-56,-56)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 495.4,
    cy: 113.7,
    r: 10.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m344 158.9c5.2 0 8.2-3.9 8-7.7-0.1-2-0.3-3.3-0.5-4.3-3.2-13.8-14.4-24-27.7-24-15.8 0-28.6 14.3-28.6 31.9s12.8 31.9 28.6 31.9c9.9 0 17-3.6 22.1-9.3 2.5-2.8 2-7.1-1-9.2-2.5-1.7-5.6-1.1-7.9 0.8-2.2 1.9-6.4 5.7-13.2 5.7-8 0-14.8-6.9-16.3-16h36.5zm-20.3-23.9c7.2 0 13.4 5.6 15.7 13.3h-31.4c2.3-7.8 8.5-13.3 15.7-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m295.8 129.2c0-3-2.2-5.4-5-5.9-8.7-1.3-16.9 1.9-21.6 7.8v-0.8c0-3.7-3-6-6-6-3.3 0-6 2.7-6 6v49c0 3.2 2.4 6 5.6 6.2 3.5 0.2 6.4-2.5 6.4-6v-25.3c0-11.2 8.4-20.4 20-19.1h1.2c3-0.2 5.4-2.8 5.4-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m501.4 135.6c0-3.3-2.7-6-6-6s-6 2.7-6 6v43.9c0 3.3 2.7 6 6 6s6-2.7 6-6v-43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m412.2 102.4c0-3.3-2.7-6-6-6s-6 2.7-6 6v26.7c-4.1-4.1-9.2-6.1-15.3-6.1-15.8 0-28.6 14.3-28.6 31.9s12.8 31.9 28.6 31.9c6.1 0 11.3-2.1 15.4-6.2 0.5 2.8 3 4.9 5.9 4.9 3.3 0 6-2.7 6-6v-77.1zm-27.2 72.5c-9.2 0-16.6-8.9-16.6-20 0-11 7.4-20 16.6-20s16.6 8.9 16.6 20-7.5 20-16.6 20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m474.8 102.4c0-3.3-2.7-6-6-6s-6 2.7-6 6v26.7c-4.1-4.1-9.2-6.1-15.3-6.1-15.8 0-28.6 14.3-28.6 31.9s12.8 31.9 28.6 31.9c6.1 0 11.3-2.1 15.4-6.2 0.5 2.8 3 4.9 5.9 4.9 3.3 0 6-2.7 6-6v-77.1zm-27.3 72.5c-9.2 0-16.6-8.9-16.6-20 0-11 7.4-20 16.6-20s16.6 8.9 16.6 20-7.4 20-16.6 20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m531.8 179.6v-44.6h5.3c2.8 0 5.3-2.1 5.5-5 0.2-3.1-2.3-5.7-5.3-5.7h-5.5v-8.4c0-3.2-2.4-6-5.6-6.2-3.5-0.2-6.4 2.5-6.4 6v8.7h-5c-2.8 0-5.3 2.1-5.5 5-0.2 3.1 2.3 5.7 5.3 5.7h5.1v44.6c0 3.3 2.7 6 6 6 3.5-0.2 6.1-2.8 6.1-6.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 139.8,
    cy: 139.8,
    r: 83.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m195.7 139.8c0-6.8-5.5-12.2-12.2-12.2-3.3 0-6.3 1.3-8.5 3.4-8.4-6-19.9-9.9-32.7-10.4l5.6-26.2 18.2 3.9c0.2 4.6 4 8.3 8.7 8.3 4.8 0 8.7-3.9 8.7-8.7s-3.9-8.7-8.7-8.7c-3.4 0-6.4 2-7.8 4.9l-20.3-4.3c-0.6-0.1-1.2 0-1.6 0.3-0.5 0.3-0.8 0.8-0.9 1.4l-6.2 29.2c-13 0.4-24.7 4.3-33.2 10.4-2.2-2.1-5.2-3.4-8.5-3.4-6.8 0-12.2 5.5-12.2 12.2 0 5 3 9.2 7.2 11.1-0.2 1.2-0.3 2.4-0.3 3.7 0 18.8 21.9 34.1 48.9 34.1s48.9-15.2 48.9-34.1c0-1.2-0.1-2.5-0.3-3.7 4.2-1.9 7.2-6.2 7.2-11.2zm-83.8 8.7c0-4.8 3.9-8.7 8.7-8.7s8.7 3.9 8.7 8.7-3.9 8.7-8.7 8.7c-4.8 0.1-8.7-3.9-8.7-8.7zm48.7 23.1c-6 6-17.4 6.4-20.7 6.4-3.4 0-14.8-0.5-20.7-6.4-0.9-0.9-0.9-2.3 0-3.2s2.3-0.9 3.2 0c3.8 3.8 11.8 5.1 17.5 5.1s13.8-1.3 17.5-5.1c0.9-0.9 2.3-0.9 3.2 0 0.8 0.9 0.8 2.3 0 3.2zm-1.6-14.3c-4.8 0-8.7-3.9-8.7-8.7s3.9-8.7 8.7-8.7 8.7 3.9 8.7 8.7c0 4.7-3.9 8.7-8.7 8.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3",
    transform: "translate(-56,-56)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    width: 598.6,
    height: 55.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    y: 223.6,
    width: 598.6,
    height: 55.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    width: 55.9,
    height: 279.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 542.7,
    width: 55.9,
    height: 279.6
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b47f5c6d735f669496ff830ef68b59c6.svg";
export { ForwardRef as ReactComponent };